// The shell-resolved state that section routes read via the Outlet context.
//
// It lives in its own module for two reasons. (1) `routes.tsx` and
// `RootLayout.tsx` both need the type, and putting it in either one makes the
// other's import a cycle. (2) The SPLIT view renders a SECOND router whose
// route elements are built once and memoised, so a value passed as a prop into
// that tree would be captured stale — the pane reads `RootCtx` instead, which
// crosses the RouterProvider boundary like any other React context and always
// yields the shell's current value.
import { createContext, useContext } from "react";

export interface RootOutletContext {
  hasCheckpointAccess: boolean | null;
  checkpointLoading: boolean;
  checkCheckpointAccess: () => void;
}

// Inert default: `null` access means "not resolved yet", which is exactly how
// Checkpoint already reads an unknown answer. A pane mounted outside the shell
// (a test, a storybook) therefore degrades to "still loading", never to
// "entitled".
const DEFAULT: RootOutletContext = {
  hasCheckpointAccess: null,
  checkpointLoading: true,
  checkCheckpointAccess: () => {},
};

export const RootCtx = createContext<RootOutletContext>(DEFAULT);

export const useRootCtx = (): RootOutletContext => useContext(RootCtx);
